var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row form-page-detail-body-container" },
    [
      _c("div", { staticClass: "w-100 d-flex justify-content-end mb-3" }, [
        _vm.showBtnUpdateTable
          ? _c(
              "button",
              {
                staticClass: "form-page-detail-button",
                on: {
                  click: function($event) {
                    _vm.openModalUpdateTable(_vm.$v.form)
                  }
                }
              },
              [_vm._v("\n      Save\n    ")]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-page-detail-wrap" },
        [
          _vm.form.is_offline_mode
            ? _c("div", { staticClass: "local-storage" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/logo/offline-mode.png"),
                    height: "16"
                  }
                }),
                _vm._v("\n      Local Storage Support\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-form-group",
            { class: { "error-input": _vm.$v.form.name.$error } },
            [
              _c("label", [_vm._v("Table Name")]),
              _vm._v(" "),
              _c("j-input", {
                attrs: {
                  disabled: _vm.disableAction,
                  placeholder:
                    "Only lowercase characters and underscore '_' are allowed, ex: name_form"
                },
                model: {
                  value: _vm.$v.form.name.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.form.name, "$model", $$v)
                  },
                  expression: "$v.form.name.$model"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            [
              _c("label", [_vm._v("Table Id")]),
              _vm._v(" "),
              _c("j-input", {
                attrs: { disabled: true },
                model: {
                  value: _vm.$v.form.id.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.form.id, "$model", $$v)
                  },
                  expression: "$v.form.id.$model"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form-page-detail-config" }, [
            _c("div", { staticClass: "config-item" }, [
              _c(
                "div",
                { staticClass: "config-item-toggle" },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("j-switch", {
                    class: {
                      disabled: _vm.disableAction || _vm.isModalUpdateTableOpen
                    },
                    attrs: {
                      disabled: _vm.disableAction || _vm.isModalUpdateTableOpen
                    },
                    model: {
                      value: _vm.form.is_share_device_info,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "is_share_device_info", $$v)
                      },
                      expression: "form.is_share_device_info"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("hr", { staticClass: "mt-2 mb-4" }),
            _vm._v(" "),
            _c("div", { staticClass: "config-item mt-2" }, [
              _c(
                "div",
                { staticClass: "config-item-toggle" },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("j-switch", {
                    class: {
                      disabled:
                        _vm.disableActionAuditLog || _vm.isModalUpdateTableOpen
                    },
                    attrs: {
                      disabled:
                        _vm.disableActionAuditLog || _vm.isModalUpdateTableOpen
                    },
                    model: {
                      value: _vm.form.is_disable_audit_log,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "is_disable_audit_log", $$v)
                      },
                      expression: "form.is_disable_audit_log"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("hr", { staticClass: "mt-2 mb-4" }),
            _vm._v(" "),
            _c("div", { staticClass: "config-item mt-2" }, [
              _c(
                "div",
                { staticClass: "config-item-toggle" },
                [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("j-switch", {
                    model: {
                      value: _vm.form.is_limit_maximum_data,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "is_limit_maximum_data", $$v)
                      },
                      expression: "form.is_limit_maximum_data"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("hr", { staticClass: "mt-2 mb-4" }),
            _vm._v(" "),
            _c("div", { staticClass: "config-item mt-2" }, [
              _c(
                "div",
                { staticClass: "config-item-toggle" },
                [
                  _vm._m(3),
                  _vm._v(" "),
                  _c("j-switch", {
                    model: {
                      value: _vm.isRateLimitActive,
                      callback: function($$v) {
                        _vm.isRateLimitActive = $$v
                      },
                      expression: "isRateLimitActive"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isRateLimitActive,
                      expression: "isRateLimitActive"
                    }
                  ],
                  staticClass: "config-item-input"
                },
                [
                  _c("p", [_vm._v("Maximum Requests")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "line" }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.limitPerSecond,
                        expression: "limitPerSecond"
                      }
                    ],
                    class: { "error-input": _vm.$v.form.rate_limit.$error },
                    attrs: { type: "number" },
                    domProps: { value: _vm.limitPerSecond },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.limitPerSecond = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("per seconds")])
                ]
              )
            ]),
            _vm._v(" "),
            _vm.switcher ? _c("hr", { staticClass: "mt-2 mb-4" }) : _vm._e(),
            _vm._v(" "),
            _vm.switcher
              ? _c(
                  "div",
                  { staticClass: "config-item mt-2" },
                  [
                    _vm._m(4),
                    _vm._v(" "),
                    _c(
                      "b-form",
                      [
                        _c("label", [_vm._v(" Service ")]),
                        _vm._v(" "),
                        _c("j-single-select", {
                          attrs: {
                            options: _vm.serviceOptions,
                            "error-required": false,
                            placeholder: "Select Service",
                            label: "name"
                          },
                          model: {
                            value: _vm.nocodeServiceTarget,
                            callback: function($$v) {
                              _vm.nocodeServiceTarget = $$v
                            },
                            expression: "nocodeServiceTarget"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v("For running process on specific service")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.isShowModalUpdateTable
        ? _c("j-modal-update-table", {
            attrs: { id: "modalUpdateTableId", "table-name": _vm.form.name },
            on: { submit: _vm.submitForm, close: _vm.closeModalUpdateTable }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "config-item-toggle-wrap" }, [
      _c("h4", { staticClass: "config-item-title" }, [
        _vm._v("Sharing Device Info")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "config-item-desc" }, [
        _vm._v(
          "The mobile app will ask for device info when performing any action on this table."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "config-item-toggle-wrap" }, [
      _c("h4", { staticClass: "config-item-title" }, [_vm._v("Disable Log")]),
      _vm._v(" "),
      _c("p", { staticClass: "config-item-desc" }, [
        _vm._v(
          "Any CREATE, UPDATE, DELETE, TRUNCATE actions on data will not be included in the audit trail log."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "config-item-toggle-wrap" }, [
      _c("h4", { staticClass: "config-item-title" }, [
        _vm._v("Data Load Maximum Limit")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "config-item-desc" }, [
        _vm._v(
          "The maximum number of data retrieves allowed is 10,000 records."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "config-item-toggle-wrap" }, [
      _c("h4", { staticClass: "config-item-title" }, [_vm._v("Rate Limits")]),
      _vm._v(" "),
      _c("p", { staticClass: "config-item-desc" }, [
        _vm._v(
          "Rate limit is a restriction on the number of requests within a specific time period to prevent resource abuse and maintain system performance."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "config-item-toggle" }, [
      _c("div", { staticClass: "config-item-toggle-wrap" }, [
        _c("h4", { staticClass: "config-item-title" }, [
          _vm._v("Specific Running Service")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f17de416", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f17de416","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/data-manager/jFormGeneral.vue
// module id = null
// module chunks = 